
import { commonMixin } from "./common";

export const userMixin = {
  mixins: [commonMixin],

  data() {
    return {
      userParams: JSON.parse(localStorage.getItem("userParams")),
    };
  },

  methods: {
    // 유저 상태 확인 (auditor.register까지 param으로 받아야 함)
    checkDeactivateUser(userData) {
      const deActivatedList = ["WITHDRAWAL", "DORMANCY"];
      const isDeactivatedUser = deActivatedList.includes(userData.status.value);
      return isDeactivatedUser;
    },

    // 유저 이름 처리 부분
    handleUserName(userData) {
      const nameObj = {
        first: userData.name
          ? userData.name.first
          : userData.first
            ? userData.first
            : "",
        last: userData.name
          ? userData.name.last
          : userData.last
            ? userData.last
            : "",
        fullName: userData.name
          ? userData.name.fullName
          : userData.fullName
            ? userData.fullName
            : "",
      };

      return nameObj.fullName;
    },
  }
};